/**
 * @module framework/plugins
 */

import { App } from '~/framework/vue';
import { recaptchaV3 } from './recaptcha-v3';

export const plugins = (app: App) => {
    recaptchaV3(app);
};
